import { styled } from "@pigment-css/react";
import { EyeOff } from "@acto/web-common/components";
import { Headline } from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { ProfileMeta } from "./ProfileSection";

const Frame = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[32],
  padding: `${theme.fieldSalesTwo.spacing[80]} ${theme.fieldSalesTwo.spacing[20]} 0`,
  color: theme.fieldSalesTwo.colors.neutral[800],
  textAlign: "center",
  overflowWrap: "anywhere",
}));

const Text = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[16],
}));

const Heading = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[4],
  paddingBottom: theme.fieldSalesTwo.spacing[8],
}));

const Subtitle = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[17],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[800],
}));

interface ProfileEmptyStateProps {
  caption?: string;
  title: string;
  subtitle: string;
}

export function ProfileEmptyState({ caption, title, subtitle }: ProfileEmptyStateProps) {
  return (
    <Frame>
      <EyeOff width={80} height={80} aria-hidden="true" />
      <Text>
        <Heading>
          {caption && <ProfileMeta>{caption}</ProfileMeta>}
          <Headline>{title}</Headline>
        </Heading>
        <Subtitle>{subtitle}</Subtitle>
      </Text>
    </Frame>
  );
}
